'use strict';

/**
 * Service to show messages in the application. These messages could be:
 * WARNINGS, ERROR, SUCCESS.
 * 
 * TODO Esto no necesariamente tiene que ser un servicio, revisar si se puede
 * sacar a una clase normal
 */
angular.module('asebiol').service('alertService', [ 'SweetAlert', '$timeout', function(SweetAlert, $timeout) {

	var alert = {
		show : false,
		style : 'success',
		icon : 'check',
		color : '#3c763d',
		statusCode : '(200)',
		message : ''
	};

	var notificationActive = null;

	/*
	 * ------------------------------------------------------------------------------
	 * SERVICE FUNCTIONS
	 * -------------------------------------------------------------------------------
	 */

	return {
		showDanger : function(msg, status) {
			alert.show = true;
			this.setMessage(msg, status);
			this.show(MESSAGE_TYPE.DANGER);
		},

		showWarning : function(msg, status) {
			alert.show = true;
			this.setMessage(msg, status);
			this.show(MESSAGE_TYPE.WARNING);
		},

		showSuccess : function(msg) {
			alert.show = true;
			this.setMessage(msg, undefined);
			this.show(MESSAGE_TYPE.SUCCESS);
		},

		showInfo : function(msg) {
			alert.show = true;
			this.setMessage(msg);
			this.show(MESSAGE_TYPE.INFO);
		},

		show : function(type) {

			if (notificationActive) {
				notificationActive.dismiss();
			}

			// create the notification
			notificationActive = new NotificationFx({
				message : '<i class="fa fa-' + type.icon + '"></i><p>' + alert.message + '</p>',
				layout : 'bar',
				effect : 'slidetop',
				type : type.style, // notice, warning or error
				onClose : function() {
					alert.show = false;
				}
			});

			notificationActive.show();
		},

		visible : function() {
			return alert.show;
		},

		hide : function() {
			alert.show = false;
			alert.message = '';
		},

		setMessage : function(msg, status) {
			if (status === undefined) {
				alert.message = msg;
			} else {
				alert.message = '(' + status + ') ' + msg;
			}

			alert.statusCode = status;
		},

		getAlert : function() {
			return alert;
		},

		showSwtMessage : function(title, text) {
			SweetAlert.swal(title, text);
		},

		showSwtQuestion : function(title, callBack) {
			this.showSwtQuestionRaw('¿Desea confirmar esta acción?', title, callBack);
		},

		showSwtWarningQuestion : function(title, callBack) {
			this.showSwtWarningQuestionRaw('¿Desea confirmar esta acción?', title, true, callBack);
		},

		showSwtQuestionRaw : function(title, text, callBack) {
			SweetAlert.swal({
				title : title,
				text : text,
				imageUrl : 'images/warning.png',
				showCancelButton : true,
				html : true,
				confirmButtonColor : "#50992e",
				confirmButtonText : "Aceptar",
				cancelButtonText : "Cancelar",
				closeOnConfirm : true,
				closeOnCancel : true
			}, function(confirmed) {
				if (confirmed)
					callBack(confirmed);
			});
		},

		showSwtWarningQuestionRaw : function(title, text, showCancelButton, callBack) {
			var showCancelbt = true;
			if (!angular.isUndefined(showCancelButton))
				showCancelbt = showCancelButton;
			SweetAlert.swal({
				title : title,
				text : text,
				imageUrl : 'images/warning2.png',
				showCancelButton : showCancelbt,
				html : true,
				customClass : "confirmwarning",
				confirmButtonText : "Aceptar",
				cancelButtonText : "Cancelar",
				closeOnConfirm : true,
				closeOnCancel : true
			}, function(confirmed) {
				if (confirmed)
					if (callBack)
						callBack(confirmed);
			});
		},

		showSwtWarning : function(title, callBack) {
			SweetAlert.swal({
				title : '¿Desea confirmar esta acción?',
				text : title,
				imageUrl : 'images/warning2.png',
				html : true,
				showCancelButton : true,
				confirmButtonColor : "#DD6B55",
				confirmButtonText : "Aceptar",
				cancelButtonText : "Cancelar",
				closeOnConfirm : true,
				closeOnCancel : true
			}, function(confirmed) {
				callBack(confirmed);
			});
		},

		askSwtForInteger : function(title, text, callBack) {
			SweetAlert.swal({
				title : title,
				text : text,
				type : 'input',
				showCancelButton : true,
				confirmButtonColor : "#50992e",
				confirmButtonText : "Aceptar",
				cancelButtonText : "Cancelar",
				closeOnConfirm : false,
				closeOnCancel : true
			}, function(inputValue) {
				if (inputValue === false) {
					return false;
				}

				if (inputValue === "") {
					SweetAlert.showInputError("Campo es obligatorio!");
					return false;
				}

				SweetAlert.close();
				callBack(inputValue);
			});
		}
	};

} ]);